import React, { FunctionComponent } from "react";

const RatingStarRibbonIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/social-medias-rewards-rating/rating/rating-star-ribbon
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m19.059 23.105 -6.177 -4.492a1.5 1.5 0 0 0 -1.764 0l-6.177 4.492A0.75 0.75 0 0 1 3.75 22.5V2.25a1.5 1.5 0 0 1 1.5 -1.5h13.5a1.5 1.5 0 0 1 1.5 1.5V22.5a0.75 0.75 0 0 1 -1.191 0.605Z"
        fill="none"
        stroke="currentcolor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="m12.53 5.791 1.249 2.458h2.127a0.582 0.582 0 0 1 0.419 1l-1.953 1.922 1.082 2.485a0.589 0.589 0 0 1 -0.839 0.737L12 12.918l-2.615 1.471a0.589 0.589 0 0 1 -0.839 -0.737l1.082 -2.485 -1.953 -1.922a0.582 0.582 0 0 1 0.419 -1h2.127l1.249 -2.454a0.594 0.594 0 0 1 1.06 0Z"
        fill="none"
        stroke="currentcolor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default RatingStarRibbonIcon;
